module.exports = __webpack_public_path__ + "static/media/check.1a949e33.svg";